module.exports = __webpack_public_path__ + "img/serbada.051748e0.png";